import Icon from '@/components/Icon/Icon';

const ChevronRightIcon = ({...rest}) => {
    return (
        <Icon width='24' height='24' fill='none' {...rest}>
            <path d='M9 4L17 12L9 20' stroke='#393E44' strokeWidth='1.5' strokeLinecap='round' />
        </Icon>
    );
};

export default ChevronRightIcon;
